// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SegmentFieldsetComponent } from './segment-fieldset.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Date2MonthsModule } from '../../fields/date2months-field/date2months.module';
import { NumberFieldModule } from '../../fields/number-field/number-field.module';
import { TextFieldModule } from '../../fields/text-field/text-field.module';
import { ButtonModule } from '../../fields/button/button.module';
import { DateModule } from "../../fields/date/date.module";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { DateFieldModule } from "libraries/module/formbuilder/fields/date-field/date-field.module";

@NgModule({
    declarations: [
        SegmentFieldsetComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        Date2MonthsModule,
        NumberFieldModule,
        TextFieldModule,
        ButtonModule,
        DateModule,
        NumberModule,
        // DateFieldModule,
    ],
    exports: [
        SegmentFieldsetComponent,
    ],
    providers: [],
})
export class SegmentModule {
}
